import styled, { css } from 'styled-components';
import { getDefaultForegroundColor, getDefaultPlaceholderColor, getPrimaryTextContrastColor } from '@mews-ui/theme';
import { getTextPresetCss } from '@optimus-web/common';
import { TEXT_PRESET_KEY } from '@optimus-web/local-tokens';
import { Badge } from '../Badge';
import { Image } from '../Image';

export type AvatarSize = 24 | 40 | 48 | 72;

export const AVATAR_SIZE = '48px';
const AVATAR_SIZE_SMALL = '40px';

const BADGE_SIZE = '16px';

export const AvatarContainerElement = styled.div`
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
`;

export interface AvatarStyleProps {
    /** @deprecated use size field instead */
    small?: boolean;
    size?: AvatarSize;
}

export const AvatarElement = styled.div<AvatarStyleProps>`
    background-color: ${getDefaultPlaceholderColor};
    overflow: hidden;
    border-radius: 50%;
    color: ${getPrimaryTextContrastColor};
    display: inline-flex;
    justify-content: center;
    align-items: center;
    ${getTextPresetCss(TEXT_PRESET_KEY['400m'])}
    mask-image: radial-gradient(white, black);
    ${(props) => {
        if (props.size) {
            return css`
                height: ${props.size}px;
                width: ${props.size}px;
                font-size: ${props.size / 2}px;
            `;
        }

        if (props.small) {
            return css`
                height: ${AVATAR_SIZE_SMALL};
                width: ${AVATAR_SIZE_SMALL};
            `;
        }

        return css`
            height: ${AVATAR_SIZE};
            width: ${AVATAR_SIZE};
        `;
    }}
`;

export const AvatarImageElement = styled(Image)`
    height: auto;
    max-width: 100%;
`;

export const TitleElement = styled.div`
    text-transform: uppercase;
    font-weight: normal;
`;

export const NotificationElement = styled(Badge)`
    position: absolute;
    left: -5%;
    top: 0;
`;
NotificationElement.defaultProps = { variant: 'primary' };

export interface BadgeElementProps {
    position: 'left' | 'right';
}

export const AvatarBadgeElement = styled.div<BadgeElementProps>`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${BADGE_SIZE};
    height: ${BADGE_SIZE};
    border-radius: 50%;
    bottom: 0;
    padding: 2px;
    box-sizing: border-box;
    background-color: ${getDefaultForegroundColor};
    ${(props) => (props.position === 'left' ? `left: 0;` : `right: 0;`)}
`;

export const BadgeImageElement = styled(Image)`
    object-fit: contain;
    width: 100%;
    height: 100%;
    border-radius: 50%;
`;

export const BadgeTitleElement = styled.div`
    width: 100%;
    height: 100%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    ${getTextPresetCss(TEXT_PRESET_KEY['100r'])}
    background-color: ${getDefaultForegroundColor};
`;
